import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getRoles } from "../../actions/userActions/roleAction";
import "./Roles.css";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import DynamicTable from "../reuse_components/DynamicTable";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import SearchInput from "../subComponents/search/SearchInput";
import CustomButton from "../subComponents/buttons/CustomButton";
import AddRoles from "./AddRoles";

function Roles() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1)
  const [isExpanded, setIsExpanded] = useState(false);
  const [previousQuery, setPreviousQuery] = useState("");
  const [query, setQuery] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [RoleData, setRoleData] = useState([]);

console.log(showModal,"modal");

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  useEffect(() => {
    dispatch(getRoles());
  }, []);
  const roles = useSelector((state) => state.roles_reducer.roles);

  const totalPages = roles?.totalPages || 0;

  const totalItems = roles?.totalCount || 0;
  const rolesResultData = roles && roles.result;
  
  const itemsPerPage = 10;
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
 
  const handleAddRoleClick = () => {
    history.push('/admin/AddRoles');
  };
  useEffect(() => {
    const pageNumber = currentPage;
  
      if (query !== previousQuery) {
        setCurrentPage(1);
      }
      dispatch(getRoles(pageNumber, SIZE_OF_PAGE, query));
      setPreviousQuery(query);
  
    }, [currentPage, query]);
  
  const handlePageChange = (page) => {
    setCurrentPage(page);
    history.push(`?page=${page}&search=${query}`);
  };
  useEffect(() => {
    const rolesData = rolesResultData?.map((roles) => ({
      ...roles,
      status: (
        <span
          style={{
            background: "#4361FF1A",
            width: "56px",
            height: "26px",
            padding: "3px 8px",
            display: "inline-block",
            textAlign: "center",
            lineHeight: "20px",
            borderRadius: "4px 0px 0px 0px",
            opacity: 1 ,
          }}
        >
          {roles.active ? "Active" : "Inactive"}
        </span>
      )
    }));
    setRoleData(rolesData);
  }, [roles]);
 
  const columns = [
    { label: "Name", accessor: "name" },
    { label: "Description", accessor: "description" },
    { label: "Status", accessor: "status" },  
  ];
  
const handleEditRole = (row) => {
  console.log("callling handle edit role");
  
  setEditData(row);
  setShowModal(true);
};
  const actions = [  
    {
        label: 'Edit Role',
        icon: <EditOutlinedIcon />,
        permission: 'CanUpdateRole',
        handler:handleEditRole,
    },
];

const handleSearchChange = (e) => {
  setQuery(e.target.value);
  setCurrentPage(1);
};
const handleAddClick = () => {
  setEditData(null);
  setShowModal(true);
};


const handleCloseModal = () => {
  setShowModal(false);
};
const handleSaveData = async () => {
  dispatch(getRoles(currentPage, SIZE_OF_PAGE, query));
  setShowModal(false);
};

  return (
    <>
    <div>
    <div className="main-container">
            <div className="content-header">
                <div className="header-navigation">
                    <BodySmallMedium text="Manage" color="#A1A2A4" />
                    <img
                        src={chevron_rightIcon} alt="Chevron Right" className="chevron-right-icon" />
                    <BodySmallMedium text="Roles" color="#1E293B" />

                </div>
            </div>
            <Heading6Regular text="Roles" color="#1E293B" />
            <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
                        value ={query}
             />
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                       {permissions && permissions.includes("CanAddRole") && (
                            <CustomButton text="Add Role" width="180px" onClick={handleAddClick} />
                        )}
                    </div>
                </div>
                <DynamicTable
                    data={ RoleData}
                    isLoading={roles === "isLoading"}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                />
                     <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
    {totalItems > 0 && (
      <CustomPagination
        currentPage={currentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        totalPages={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
      />
    )}
  </div>
            </div>
        </div>
        {showModal && (
        <AddRoles
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
    </div>
        
    
    </>
  );
}

export default Roles;
